import en from './en'

const translations = {
  en: en,
}

export default translations